// extracted by mini-css-extract-plugin
module.exports = {"notifier":"notifier_notifier__9mtk-"};